/* eslint-disable import/prefer-default-export */

export const SELECTED_VENUE_OWNERSHIP_CHANGED = 'SELECTED_VENUE_OWNERSHIP_CHANGED';

export const VENUE_OWNERSHIP_UPDATED = 'VENUE_OWNERSHIP_UPDATED';
export const SEATING_SETTINGS_UPDATED = 'SEATING_SETTINGS_UPDATED';
export const CUSTOM_FIELDS_CHANGED = 'CUSTOM_FIELDS_CHANGED';
